'use strict';

import {ListCtrl} from './listctrl.js';

import {changelogModel} from "../../models/changelogmodel.js";

export class ChangeLogListCtrl extends ListCtrl
{
	storageNames = {
		query: 'ChangeLogListCtrl'
	};
	
	query = {
		order: '',
		limit: 20,
		page: 1,
		filters: {
			query: {
				value: ''
			}
		}
	};
	defaultQuery = {
		order: '',
		limit: 20,
		page: 1,
		filters: {
			query: {
				value: ''
			}
		}
	};
	
	setData(data){
		this.data = [];
		for(let ln of data){
			this.data.push(new changelogModel(ln, this.$filter, this.jsDataService));
		}
	}
	
	getColValue(row, col){
		if(typeof(row[col]) === 'undefined'){
			return '';
		}
		if(row instanceof changelogModel){
			return row.getValue(col);
		}
		return row[col];
	}
	
	
}


